import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { EVENT_TYPE } from '@root/config';

interface MessageType {
  key: EVENT_TYPE;
  value: any;
  id?: string; // 用于标识某事件类型下的某个身份
}

/** @deprecated */
@Injectable({
  providedIn: 'root'
})
export class EventBusService {
  id = Math.random();

  private eventBusSource = new Subject<MessageType>();

  public eventBus$ = this.eventBusSource.asObservable();

  sendMessage(message: MessageType) {
    this.eventBusSource.next(message);
  }

  constructor() {}
}
